/* Stained Concept theme JS */
(function () {
  'use strict';

  // Reveal on scroll
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );
  document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

  // Sticky header shadow
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile drawer
  const drawer = document.querySelector('.mobile-drawer');
  const overlay = document.querySelector('.drawer-overlay');
  const hamburger = document.querySelector('.hamburger');
  const closeDrawer = () => {
    drawer && drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
  };
  if (hamburger && drawer) {
    hamburger.addEventListener('click', () => {
      drawer.classList.add('is-open');
      overlay && overlay.classList.add('is-open');
    });
  }
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // Cart drawer
  const cartDrawer = document.querySelector('.cart-drawer');
  const openCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    refreshCart();
  };
  const closeCart = () => {
    cartDrawer && cartDrawer.classList.remove('is-open');
    if (drawer && !drawer.classList.contains('is-open')) overlay && overlay.classList.remove('is-open');
  };
  document.querySelectorAll('[data-cart-toggle]').forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  document.querySelectorAll('[data-cart-close]').forEach((el) => el.addEventListener('click', closeCart));
  if (overlay) overlay.addEventListener('click', closeCart);

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
    } catch (e) {}
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    const itemsEl = document.querySelector('.cart-drawer__items');
    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    const countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach((el) => { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? '' : 'none'; });
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    const goalEl = document.querySelector('[data-cart-goal]');
    if (goalEl) {
      const threshold = parseInt(goalEl.dataset.threshold || '10000', 10);
      const remaining = Math.max(0, threshold - cart.total_price);
      const pct = Math.min(100, (cart.total_price / threshold) * 100);
      goalEl.querySelector('[data-cart-goal-text]').textContent = remaining > 0
        ? `${money(remaining)} away from free shipping`
        : 'You qualify for free shipping!';
      goalEl.querySelector('[data-cart-goal-fill]').style.width = pct + '%';
    }

    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty</div>';
      return;
    }
    itemsEl.innerHTML = cart.items.map((item) => `
      <div class="cart-line" data-key="${item.key}">
        <div class="cart-line__media"><img src="${item.image}" alt="${item.title}"></div>
        <div>
          <div class="cart-line__title">${item.product_title}</div>
          ${item.variant_title ? `<div class="cart-line__variant">${item.variant_title}</div>` : ''}
          <div class="cart-line__qty">
            <button data-qty-down>−</button>
            <input type="text" value="${item.quantity}" readonly>
            <button data-qty-up>+</button>
          </div>
          <a href="#" class="cart-line__remove" data-remove>Remove</a>
        </div>
        <div class="cart-line__price">${money(item.final_line_price)}</div>
      </div>
    `).join('');

    itemsEl.querySelectorAll('.cart-line').forEach((line) => {
      const key = line.dataset.key;
      const item = cart.items.find((i) => i.key === key);
      line.querySelector('[data-qty-up]').addEventListener('click', () => updateQty(key, item.quantity + 1));
      line.querySelector('[data-qty-down]').addEventListener('click', () => updateQty(key, item.quantity - 1));
      line.querySelector('[data-remove]').addEventListener('click', (e) => { e.preventDefault(); updateQty(key, 0); });
    });
  }

  async function updateQty(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      const cart = await res.json();
      renderCart(cart);
    } catch (e) {}
  }

  // Quick Add
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.quickAdd;
    btn.disabled = true;
    const original = btn.textContent;
    btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }),
      });
      if (!res.ok) throw new Error();
      btn.textContent = 'Added ✓';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1000);
      openCart();
    } catch (err) {
      btn.textContent = 'Error';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500);
    }
  });

  // Initial cart count
  refreshCart();
})();
